import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {AdminFile} from "apis/Admin";

// First, create the thunk
export const addPodcastRequest = createAsyncThunk("addPodcast", async (args) => {
  const response = await AdminFile.post("podcast/create", args);
  return response.data;
});


//edit podcast
export const editPodcastRequest = createAsyncThunk("editPodcast", async (args) => {
  const response = await AdminFile.put("podcast/edit", args);
  return response.data;
});


// Then, handle actions in your reducers:
const addPodcastSlice = createSlice({
  name: "addPodcast",
  initialState: { message: "",  loading: false },
  reducers: { },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [addPodcastRequest.fulfilled]: (state, action) => {
      // Add key to the state array
      return { ...state, message: action.payload.message, loading: false };
    },
    [addPodcastRequest.pending]: (state) => {
      return { ...state, loading: true };
    },
    [addPodcastRequest.rejected]: (state, _action) => {
      return {
        ...state,
        message: "Failed",
        loading: false,
      };
    },
    [editPodcastRequest.fulfilled]: (state, action) => {
      // Add key to the state array
      return { ...state, message: action.payload.message, loading: false };
    },
    [editPodcastRequest.pending]: (state) => {
      return { ...state, loading: true };
    },
    [editPodcastRequest.rejected]: (state, _action) => {
      return {
        ...state,
        message: "Failed",
        loading: false,
      };
    },
  },
});



export default addPodcastSlice.reducer;
